import {
  type PostUpdateUserGroupMembershipDto,
  UpdateUserGroupMembershipResponseDtoStatus,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type ValueOf } from 'ts-essentials';
import { type RequestStatus } from '../../types';

export const UpdateUserGroupMembershipResponseStatus =
  UpdateUserGroupMembershipResponseDtoStatus;

export type UpdateUserGroupMembershipResponseStatus = ValueOf<
  typeof UpdateUserGroupMembershipResponseStatus
>;

export type UpdateUserGroupMembershipState =
  RequestStatus<UpdateUserGroupMembershipResponseStatus>;

const initialState: UpdateUserGroupMembershipState = {
  pending: false,
  status: null,
};

export const updateUserGroupMembershipSlice = createSlice({
  initialState,
  name: 'updateUserGroupMembership',
  reducers: {
    updateUserGroupMembershipFailed: (
      state: UpdateUserGroupMembershipState,
      action: PayloadAction<UpdateUserGroupMembershipResponseStatus>,
    ) => {
      state.pending = false;
      state.status = action.payload;
    },
    updateUserGroupMembershipRequested: (
      _state: UpdateUserGroupMembershipState,
      _action: PayloadAction<PostUpdateUserGroupMembershipDto>,
    ) => {
      /* handled by saga */
    },
    updateUserGroupMembershipReset: () => {
      return initialState;
    },
    updateUserGroupMembershipStarted: (state) => {
      state.pending = true;
    },
    updateUserGroupMembershipSucceeded: (
      state: UpdateUserGroupMembershipState,
      action: PayloadAction<UpdateUserGroupMembershipResponseStatus>,
    ) => {
      state.pending = false;
      state.status = action.payload;
    },
  },
});
